export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingservice) {
        const youtubeApiUrl = 'https://www.youtube.com/iframe_api';
        let embedUrl;

        init();

        function init() {
            embedUrl = ele.getAttribute('data-video-embed-url');
            initVideoElem(ele);
        }

        function initVideoElem(videoContainer) {
            if (embedUrl.indexOf('vimeo') !== -1) {
                return initVimeo()
                    .then(updateVideoElem)
                    .then(setupVimeoEvents);
            } else if (embedUrl.indexOf('youtube') !== -1) {
                return loadYouTubeApi().then(() =>
                    createYouTubeIframe(videoContainer)
                );
            }
            return initEmbedIframe().then(updateVideoElem);
        }

        function updateVideoElem(newEle) {
            if (ele !== newEle) {
                ele.replaceWith(newEle);
                return newEle;
            }
            return ele;
        }

        function createYouTubeIframe(videoContainer) {
            const videoId = embedUrl.split(/embed\//)[1].split('"')[0];

            // eslint-disable-next-line no-new
            new YT.Player(videoContainer, {
                videoId,
                events: {
                    onStateChange(event) {
                        if (event.data === YT.PlayerState.PLAYING) {
                            onPlayEvent(embedUrl);
                        }
                    },
                },
                playerVars: {
                    wmode: 'transparent',
                    hl: 'no',
                    rel: '0',
                    color: 'white',
                },
            });

            return Promise.resolve(videoContainer);
        }

        function loadYouTubeApi() {
            if (typeof YT != 'undefined') {
                return Promise.resolve();
            } else if (window.onYouTubeIframeAPIReady) {
                // script loading in progress, this prevents a race condition with more than
                // one video on the page;
                return new Promise(resolve => {
                    window.setTimeout(() => {
                        resolve(loadYouTubeApi());
                    }, 100);
                });
            } else {
                return new Promise(resolve => {
                    // Register the method that YouTube Iframe Player API wants to call
                    window.onYouTubeIframeAPIReady = function() {
                        resolve();
                    };

                    // Load the IFrame Player API code asynchronously.
                    const tag = document.createElement('script');
                    tag.src = youtubeApiUrl;
                    document.head.appendChild(tag);
                });
            }
        }

        function initEmbedIframe() {
            const iframe = document.createElement('iframe');
            iframe.src = embedUrl;
            iframe.width = '640';
            iframe.height = '360';
            iframe.frameBorder = '0';
            iframe.allowFullscreen = true;
            iframe.setAttribute('data-automation-id', 'embeded-video');
            return Promise.resolve(iframe);
        }

        function initVimeo() {
            embedUrl += '?api=1&loop=1';
            return initEmbedIframe();
        }

        function setupVimeoEvents(iframe) {
            if (window.postMessage) {
                window.addEventListener('message', event => {
                    if (isVimeoEvent(event)) {
                        const data = JSON.parse(event.data);
                        if (data.event === 'ready') {
                            iframe.contentWindow.postMessage(
                                JSON.stringify({
                                    method: 'addEventListener',
                                    value: 'play',
                                }),
                                embedUrl
                            );
                        } else if (data.event === 'play') {
                            onPlayEvent(embedUrl);
                        }
                    }
                });
            }
        }

        function isVimeoEvent(event) {
            return event.origin.indexOf('vimeo.com') !== -1;
        }

        function onPlayEvent() {
            trackingservice.deprecatedTrackEvent('WA.VIDEO_PLAY');
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/embeddedVideo.js